import { Controller } from "stimulus"

export default class extends Controller {
    static values = {
        id: String,
        errorDetail: String,
        patientId: String,
        name: String,
        kana: String
    }

    open() {
        console.log(this)
        // 独立したモーダルコントローラーにイベントを発行
        const event = new CustomEvent('link-modal:open', {
            detail: {
                detailId: this.idValue,
            },
            bubbles: true
        })
        this.element.dispatchEvent(event)
    }
}
